<template>
  <v-dialog ref="menu"
            v-model="showTimePicker"
            persistent
            :return-value.sync="time"
            width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field outlined
                    :append-icon="readonly ? null: 'fas fa-clock'"
                    :label="label"
                    :placeholder="label"
                    :value="time"
                    readonly
                    :hide-details="hideDetails"
                    v-on="readonly ? null : on"
                    :rules="rules"></v-text-field>
    </template>
    <v-time-picker v-model="pickerTime"
                   scrollable>
      <v-btn text color="primary" @click="showTimePicker = false">Cancel</v-btn>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="clearTime">Clear</v-btn>
      <v-btn text color="primary" @click="$refs.menu.save(pickerTime)">OK</v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
import {ref, watch} from "@vue/composition-api";

export default {
  name: 'TimePickerInput',
  props: {
    value: String,
    label: String,
    readonly: Boolean,
    hideDetails: [Boolean, String],
    rules: Array,
  },
  setup(props, {root, emit}) {
    const time = ref(null);
    const pickerTime = ref(null);
    const clearTime = function () {
      time.value = null;
      pickerTime.value = null;
      showTimePicker.value = false;
    };
    watch(
        time,
        (newVal, oldVal) => {
          if (newVal !== oldVal) {
            emit('input', newVal)
          }
        }
    );
    watch(() => props.value, (newValue) => {
      if (newValue) {
        time.value = newValue;
        pickerTime.value = newValue;
      } else {
        time.value = null;
        pickerTime.value = null;
      }
    }, {deep: true, immediate: true});

    const showTimePicker = ref(false);

    return {
      time,
      pickerTime,
      clearTime,
      showTimePicker,
    }
  }
}
</script>
